<template>
  <b-card title="Renk Fotoğrafı">
    <b-row>
      <b-col
        v-if="dataItem.renk_img"
        cols="12"
        md="auto"
        class="text-center"
      >
        <div class="border-1 bordered bg-light p-2 rounded">
          <b-img
            :src="baseURL + '/media/features/' + dataItem.renk_img"
            fluid-grow
          />
        </div>
        <b-button
          class="mt-1"
          variant="danger"
          pill
          size="sm"
          @click="removeLogo"
        >
          <FeatherIcon icon="TrashIcon" /> Görseli Sil
        </b-button>
      </b-col>
      <b-col>
        <b-form-group
          label="Dosya Yükle"
          label-for="logo"
        >
          <b-form-file
            id="renk_img"
            v-model="upload_logo"
            placeholder="Bir görsel dosyası seçin veya buraya bırakın..."
            drop-placeholder="görsel dosyasını buraya bırakın..."
            browse-text="Dosya Seçin"
            :disabled="!!dataItem.renk_img"
          />
        </b-form-group>
        <b-button
          variant="success"
          :disabled="!upload_logo"
          @click="uploadLogo"
        >
          Dosya Yükle
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {
  BCard, BRow, BCol, BImg, BFormGroup, BFormFile, BButton,
} from 'bootstrap-vue'

export default {
  name: 'RenkLogoCard',
  components: {
    BCard, BRow, BCol, BImg, BFormGroup, BFormFile, BButton,
  },
  data() {
    return {
      baseURL: this.$store.state.app.baseURL,
      upload_logo: null,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['features/dataItem']
    },
  },
  methods: {
    removeLogo() {
      this.$store.dispatch('cropperUploads/removeData', {
        filename: this.dataItem.renk_img,
        component: 'renk_img',
        params: 'renk_img',
      })
        .then(response => {
          if (response.status) {
            this.dataItem.renk_img = null
          }
        })
    },
    uploadLogo() {
      this.$store.dispatch('cropperUploads/uploadImage', {
        folder: 'features',
        resize: true,
        width: 293,
        thumb: false,
        webp: false,
        ordering: 1,
        component: 'renk_img',
        params: 'renk_img',
        item_id: this.dataItem.id,
        upload_image: this.upload_logo,
        filename: 'renk_img.png' || 'renk_img.png',
      })
        .then(response => {
          if (response.status) {
            console.log(response)
            this.dataItem.mediaData = response.data
            this.dataItem.renk_img = response.data.filename
          }
        })
    },
  },
}
</script>
